const CareerPathwaysPslfVaultLayout = <template>{{outlet}}</template>;

export default CareerPathwaysPslfVaultLayout;
